import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {AuthGuardService} from '../../../guards/auth-guard.service';
import {ReservationsComponent} from './reservations.component';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.reservations.pageInRouting,
    data: {data: PAGES_AND_PATHS.reservations},
    component: ReservationsComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./reservations.module').then(m => m.ReservationsModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReservationsRoutingModule { }
